<template>
  <!--==================
    component edit  places to visit page (admin)

    NOTE:
      1. form2 variable is used for subsection gallery selection
    ===============-->

  <div class="col-12 pb-20 pt-20 px-0">
    <!-- places to visit page form -->
    <form
      v-if="isPageLoaded"
      id="destination-form"
      @submit.prevent="updatePlacesToVisit"
      class="destination-form col"
      autocomplete="off"
    >
      <!-- title input -->
      <div class="form-row col-md-10">
        <div class="form-group col mt-0">
          <input
            id="title"
            type="text"
            class="form-control destination-title"
            placeholder="Page Title"
            maxlength="57"
            v-model="form.title"
            @input="$v.form.title.$touch()"
            @change="titleSlug()"
          />
          <span v-if="$v.form.title.$dirty && $v.form.title.$invalid" class="text-danger d-block small p-2">
            This field is required
          </span>
        </div>
      </div>

      <!-- description input -->
      <div class="form-row col-md-10 mt-3">
        <div class="form-group col mt-0">
          <textarea
            type="text"
            class="form-control destination-sub-title"
            placeholder="Page Description"
            maxlength="160"
            v-model="form.shortDescription"
            @input="$v.form.shortDescription.$touch()"
          ></textarea>
          <span
            v-if="$v.form.shortDescription.$dirty && $v.form.shortDescription.$invalid"
            class="text-danger d-block small p-2"
          >
            This field is required
          </span>
        </div>
      </div>

      <!-- post slug input -->
      <div class="form-row col-md-10 mt-3">
        <div class="form-group col mt-0">
          <!-- <label class="mb-3">Page slug:</label> -->
          <input
            type="text"
            class="form-control"
            v-model="form.slug"
            @input="$v.form.slug.$touch()"
            placeholder="page-slug"
          />
          <span v-if="$v.form.slug.$dirty && $v.form.slug.$invalid" class="text-danger d-block small p-2">
            This field is required
          </span>
        </div>
      </div>

      <!-- page image input -->
      <div class="form-row col-md-10 mt-3" v-for="(image, index) in form.pageImages" :key="'page-image-' + index">
        <div class="col-12 mb-2">
          <a
            @click="imageSelectNew($event, 'tour-day-gallery')"
            class="select-thumb"
            :href="'#page-' + index"
          >
            Select photo from library
          </a>
        </div>
        <div class="form-group col-md-10 mt-0">
          <input
            type="text"
            class="form-control"
            placeholder="https://gallery.safaritreksbeach.com/images..."
            v-model="form.pageImages[index]"
            @change="pageImageRemove(index)"
          />
        </div>
        <div class="form-group col-md-10 mt-0">
          <img v-if="image != ''" :src="image" width="200" />
        </div>
      </div>

      <button @click="addPageImage()" class="btn btn-secondary btn-sm ml-3 mt-3" type="button">
        <i class="icofont-plus-circle"></i> Add image
      </button>

      <!-- section input -->
      <div class="col-md-10 mt-5 pl-0">
        <div class="mb-4" v-for="(section, index) in form.sections" :key="'section' + index">
          <div class="d-flex align-items-center justify-content-between mx-3">
            <h3>SECTION {{ index + 1 }}:</h3>
            <button v-if="index > 0" @click="removeSection(index)" class="btn btn-secondary btn-sm ml-3" type="button">
              <i class="icofont-minus-circle"></i> Remove section
            </button>
          </div>
          <hr class="section mx-3" />

          <div class="form-group col mt-0">
            <input
              type="text"
              class="form-control destination-sub-title"
              placeholder="Section Title"
              maxlength="57"
              v-model="form.sections[index].title"
              @input="$v.form.sections.$each[index].title.$touch()"
            />
            <span
              v-if="$v.form.sections.$each[index].title.$dirty && $v.form.sections.$each[index].title.$invalid"
              class="text-danger d-block small"
            >
              This field is required
            </span>
          </div>

          <div class="form-group col mt-3">
            <input
              type="text"
              class="form-control destination-sub-title"
              placeholder="Section Heading for SEO"
              maxlength="57"
              v-model="form.sections[index].heading"
              @input="$v.form.sections.$each[index].heading.$touch()"
            />
            <span
              v-if="$v.form.sections.$each[index].heading.$dirty && $v.form.sections.$each[index].heading.$invalid"
              class="text-danger d-block small"
            >
              This field is required
            </span>
          </div>

          <div class="form-group col mt-3">
            <input
              type="text"
              class="form-control destination-sub-title"
              placeholder="Section content Title"
              maxlength="57"
              v-model="form.sections[index].subTitle"
              @input="$v.form.sections.$each[index].subTitle.$touch()"
            />
            <span
              v-if="$v.form.sections.$each[index].subTitle.$dirty && $v.form.sections.$each[index].subTitle.$invalid"
              class="text-danger d-block small"
            >
              This field is required
            </span>
          </div>

          <!-- section meta description input -->
          <div class="form-group col mt-3">
            <textarea
              type="text"
              class="form-control destination-sub-title"
              placeholder="Meta description"
              maxlength="160"
              v-model="form.sections[index].shortDescription"
              @input="$v.form.sections.$each[index].shortDescription.$touch()"
            ></textarea>
            <span
              v-if="
                $v.form.sections.$each[index].shortDescription.$dirty &&
                $v.form.sections.$each[index].shortDescription.$invalid
              "
              class="text-danger d-block small p-2"
            >
              This field is required
            </span>
          </div>

          <!-- section slug -->
          <div class="form-group col mt-3">
            <input
              type="text"
              class="form-control destination-sub-title"
              placeholder="section-slug"
              v-model="form.sections[index].slug"
              @input="$v.form.sections.$each[index].slug.$touch()"
            />
            <span
              v-if="$v.form.sections.$each[index].slug.$dirty && $v.form.sections.$each[index].slug.$invalid"
              class="text-danger d-block small"
            >
              This field is required
            </span>
          </div>

          <div v-for="(subSection, sub_index) in form.sections[index].subSections" :key="sub_index + 'sub' + index">
            <hr class="subsection mx-3" />
            <button
              v-if="sub_index > 0"
              @click="removeSubSection(index, sub_index)"
              class="btn btn-danger btn-sm ml-3 mt-3"
              type="button"
            >
              <i class="icofont-minus-circle"></i> Remove Subsection
            </button>
            <div class="mt-3 row px-2">
              <a class="select-thumb col-md-4 mt-3 col-sm-12" :href="'#' + index">Input photo/youtube video URL </a>
              <a
                @click="imageSelectNew($event, 'tour-day-gallery')"
                class="select-thumb col-md-4 mt-3 col-sm-12"
                :href="'#' + index + '-' + sub_index"
              >
                Select photo from all library
              </a>

              <label class="select-thumb col-md-4 mt-3 col-sm-12" style="display: inline-block; color: #666666">
                <input
                  @change="handleImage($event, index, sub_index)"
                  type="file"
                  style="display: none"
                  accept="image/png, image/gif, image/jpeg"
                />
                Upload your own photo
              </label>
            </div>
            <div class="form-group mt-3 px-3">
              <input
                type="text"
                class="form-control"
                v-model="form2.sections[index].subSections[sub_index].image"
                placeholder="Image URL/youtube URL"
                @change="postImage(index, sub_index)"
              />
            </div>
            <div
              v-if="
                form2.sections[index].subSections[sub_index].type == 'image' &&
                form2.sections[index].subSections[sub_index].image != ''
              "
            >
              <img
                class="mt-3 w-100"
                v-if="form2.sections[index].subSections[sub_index].image"
                :src="form2.sections[index].subSections[sub_index].image"
                alt="Invalid Image"
              />
              <br />
              <a class="btn btn-primary m-3" @click="addAssets(index, sub_index)">Add Image</a>
            </div>
            <div
              v-if="
                form2.sections[index].subSections[sub_index].type == 'video' &&
                form2.sections[index].subSections[sub_index].image != ''
              "
              class="mt-3"
            >
              <video-embed
                css="embed-responsive-21by9"
                :params="{ showinfo: 0, controls: 0 }"
                :src="form2.sections[index].subSections[sub_index].image"
              ></video-embed>
              <br />
              <a class="btn btn-primary m-3" @click="addAssets(index, sub_index)">Add Video</a>
            </div>
            <div class="text-center mt-3" v-if="isUploading">Uploading image now, please wait...</div>
            <div class="text-center text-danger mt-3" v-if="isUploadingFailed">
              Uploading failed. Please check file type and try again.
            </div>

            <div class="row text-center w-100 mt-5">
              <div
                v-for="(photo, index_p) in form.sections[index].subSections[sub_index].gallery"
                :key="index + ' ' + index_p"
                class="col-lg-3 col-md-4 col-6"
              >
                <div class="d-block mb-4 position-relative">
                  <div class="thumbnail-delete">
                    <i @click="removeAssets(index, sub_index, index_p)" class="icofont-close-squared-alt"></i>
                  </div>
                  <img v-if="photo.type == 'image'" class="img-fluid img-thumbnail" :src="photo.url" />
                  <video-embed
                    v-if="photo.type == 'video'"
                    css="embed-responsive-21by9"
                    :params="{ showinfo: 0, controls: 0 }"
                    :src="photo.url"
                  ></video-embed>
                </div>
              </div>
            </div>

            <div class="form-group col">
              <vue-editor
                v-model="form.sections[index].subSections[sub_index].description"
                :key="sub_index + 'newland' + index"
                useCustomImageHandler
                @image-added="handleImageAdded"
                @image-removed="handleImageRemoved"
                :editorOptions="editorSettings"
              ></vue-editor>
            </div>
          </div>
          <button @click="addSubSection(index)" class="btn btn-secondary btn-sm mt-3 mb-5 ml-3" type="button">
            <i class="icofont-plus-circle"></i> Add Subsection
          </button>
          <!-- section button -->
          <div class="form-row col my-3 mx-0">
            <div class="form-group col-md-4 mt-0">
              <input
                type="text"
                class="form-control"
                placeholder="Section button name"
                v-model="form.sections[index].button.name"
              />
            </div>
            <div class="form-group col mt-0">
              <input
                type="text"
                class="form-control"
                placeholder="Section button url"
                v-model="form.sections[index].button.url"
              />
            </div>
          </div>
          <RelevantPacakges
            class="mt-5"
            v-model="form.sections[index].packages"
            :sectionNumber="index"
            :key="index"
          ></RelevantPacakges>
          <!-- climate data section -->
          <div class="form-check mb-2 ml-3">
            <input
              type="checkbox"
              class="form-check-input"
              :id="'isClimate' + index"
              v-model="form.sections[index].climate.isShow"
            />
            <label class="form-check-label" :for="'isClimate' + index">
              <strong>Insert Climate Data in this section</strong>
            </label>
          </div>
          <div v-if="form.sections[index].climate.isShow">
            <div class="table-responsive">
              <table class="table table-sm table-nowrap card-table table-bordered table-striped">
                <thead class="thead-dark">
                  <tr>
                    <th>Month</th>
                    <th>Jan</th>
                    <th>Feb</th>
                    <th>Mar</th>
                    <th>Apr</th>
                    <th>May</th>
                    <th>Jun</th>
                    <th>Jul</th>
                    <th>Aug</th>
                    <th>Sep</th>
                    <th>Oct</th>
                    <th>Nov</th>
                    <th>Dec</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Temperature</td>
                    <td v-for="(data, index_t) in form.sections[index].climate.temperature" :key="'temp' + index_t">
                      <input
                        class="form-control form-control-sm"
                        type="number"
                        v-model="form.sections[index].climate.temperature[index_t]"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Rainfall</td>
                    <td v-for="(data, index_t) in form.sections[index].climate.rainfall" :key="'rain' + index_t">
                      <input
                        class="form-control form-control-sm"
                        type="number"
                        v-model="form.sections[index].climate.rainfall[index_t]"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <button @click="addSection()" class="btn btn-secondary btn-sm ml-3" type="button">
          <i class="icofont-plus-circle"></i> Add Section
        </button>
      </div>
      <!-- form submit -->
      <div class="col pb-4 mt-5">
        <div class="form-row col-md-10">
          <button type="submit" class="btn btn-success btn-sm col-4" :disabled="$v.form.$invalid">
            <span>Submit Post</span>
          </button>
        </div>
      </div>
    </form>
    <DestinationImageModal></DestinationImageModal>
  </div>
</template>

<script>
import $ from "jquery";
import { required } from "vuelidate/lib/validators";
import { mapGetters, mapActions } from "vuex";
import { pagePreventLeave, pageLeave, randStrId } from "@/assets/js/custom-function";
import DestinationImageModal from "@/components/DestinationImageModal.vue";
import RelevantPacakges from "@/components/RelevantPacakges.vue";

import { VueEditor, Quill } from "vue2-editor";
import { ImageDrop } from "quill-image-drop-module";
import ImageResize from "quill-image-resize-module";

Quill.register("modules/imageDrop", ImageDrop);
Quill.register("modules/imageResize", ImageResize);

export default {
  name: "newLandingThings",

  components: {
    VueEditor,
    DestinationImageModal,
    RelevantPacakges,
  },

  data() {
    return {
      form2: { sections: [{ subSections: [{ image: "", type: "image" }] }] },
      form: {
        title: "",
        shortDescription: "",
        slug: "",
        pageImages: [""],
        sections: [
          {
            heading: "",
            subTitle: "",
            shortDescription: "",
            packages: [],
            button: { name: "", url: "" },
            slug: "",
            climate: {
              isShow: false,
              temperature: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
              rainfall: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            },
            subSections: [
              {
                description: "",
                gallery: [],
                image: "",
                type: "image",
              },
            ],
          },
        ],
      },
      isUploading: false,
      isUploadingFailed: false,

      editorSettings: {
        modules: {
          imageDrop: true,
          imageResize: {},
        },
      },

      isPageLoaded: false,
    };
  },

  computed: {
    ...mapGetters(["tourPackage", "placetovisitPost"]),
    postId() {
      return this.$route.params.id;
    },
  },

  mounted() {
    pagePreventLeave();
    this.hideBarLoading();
    this.$eventHub.$on("app-mounted", async () => {
      await this.fetchPlacestovisitPost(this.postId);

      $.extend(this.form, this.placetovisitPost);

      const pageImages =
        this.placetovisitPost.pageImages && this.placetovisitPost.pageImages.length
          ? [...this.placetovisitPost.pageImages]
          : [""];
      this.$set(this.form, "pageImages", pageImages);

      // add fields to form2
      for (let i = 0; i < this.form.sections.length; i++) {
        this.form2.sections.push({ subSections: [{ image: "", type: "image" }] });
        for (let j = 0; j < this.form.sections[i].subSections.length; j++) {
          this.form2.sections[i].subSections.push({ image: "", type: "image" });
        }
      }

      this.isPageLoaded = true;

      this.$eventHub.$on("day-gallery-photo", (image, twoIndex) => {
        if (!image) return;
        if (twoIndex.startsWith("page-")) {
          const pageIndex = parseInt(twoIndex.split("-")[1], 10);
          this.$set(this.form.pageImages, pageIndex, image);
          return;
        }
        var arr = twoIndex.split("-");
        this.form2.sections[arr[0]].subSections[arr[1]].image = image;
        this.form2.sections[arr[0]].subSections[arr[1]].type = "image";
      });
    });
  },

  validations() {
    return {
      form: {
        title: { required },
        shortDescription: { required },
        slug: { required },
        sections: {
          $each: {
            heading: { required },
            subTitle: { required },
            title: { required },
            shortDescription: { required },
            slug: { required },
          },
        },
      },
    };
  },

  methods: {
    ...mapActions([
      "hideBarLoading",
      "showSpinnerLoading",
      "hideSpinnerLoading",
      "updatePlacestovisitPost",
      "fetchPlacestovisitPost",
      "uploadPlacevisitPhoto",
      "deletePlacevisitPhoto",
    ]),

    getGalleryImageUrls() {
      const urls = [];
      for (const section of this.form.sections) {
        for (const sub of section.subSections || []) {
          for (const item of sub.gallery || []) {
            if (item.type === "image" && item.url && item.url.trim()) {
              urls.push(item.url);
            }
          }
        }
      }
      return urls;
    },

    buildPlaceToVisitPayload() {
      const post = JSON.parse(JSON.stringify(this.form));
      for (let i = 0; i < post.sections.length; i++) {
        for (let j = 0; j < post.sections[i].subSections.length; j++) {
          delete post.sections[i].subSections[j].image;
          delete post.sections[i].subSections[j].type;
        }
      }
      delete post.createdAt;
      delete post.id;
      delete post.published;
      delete post.updatedAt;
      let pageImages = (post.pageImages || []).filter((url) => url && url.trim() !== "");
      if (pageImages.length === 0) {
        pageImages = this.getGalleryImageUrls();
      }
      post.pageImages = pageImages;
      return post;
    },

    async updatePlacesToVisit() {
      // this.showSpinnerLoading();

      var data = {
        id: this.postId,
        post: this.buildPlaceToVisitPayload(),
      };

      await this.updatePlacestovisitPost(data)
        .then((_res) => {
          this.hideSpinnerLoading();
          $.alert("Post updated successfully");
          pageLeave();

          setTimeout(() => {
            window.location.href = "/dashboard/places-to-visit/page";
          }, 2000);
        })
        .catch((_error) => {
          this.hideSpinnerLoading();
          $.alert("post submision failed!");
        });
    },

    titleSlug() {
      let title = $("#title").val();
      this.form.slug = title.toLowerCase().replace(/ /gi, "-");
    },

    postImage(index, sub_index) {
      if (this.isYoutubeURL(this.form2.sections[index].subSections[sub_index].image))
        this.form2.sections[index].subSections[sub_index].type = "video";
      else this.form2.sections[index].subSections[sub_index].type = "image";
    },

    addSubSection(index) {
      this.form.sections[index].subSections.push({
        description: "",
        gallery: [],
        image: "",
        type: "image",
      });
      this.form2.sections[index].subSections.push({
        image: "",
        type: "image",
      });
    },

    removeSubSection(index, sub_index) {
      this.form.sections[index].subSections.splice(sub_index, 1);
      this.form2.sections[index].subSections.splice(sub_index, 1);
    },

    addSection() {
      this.form2.sections.push({ subSections: [{ image: "", type: "image" }] });
      this.form.sections.push({
        heading: "",
        subTitle: "",
        shortDescription: "",
        packages: [],
        button: { name: "", url: "" },
        slug: "",
        climate: {
          isShow: false,
          temperature: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          rainfall: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        subSections: [
          {
            description: "",
            gallery: [],
            image: "",
            type: "image",
          },
        ],
      });
    },

    removeSection(index) {
      this.form.sections.splice(index, 1);
      this.form2.sections.splice(index, 1);
    },

    //image related method
    handleImage(e, index, sub_index) {
      var currentdate = new Date();
      var datetime =
        "_" +
        currentdate.getFullYear() +
        "_" +
        (currentdate.getMonth() + 1) +
        "_" +
        currentdate.getDate() +
        "_" +
        currentdate.getHours() +
        "_" +
        currentdate.getMinutes() +
        "_" +
        currentdate.getSeconds();
      let filename = "CUSTOM_PLACES_TO_VISIT";
      filename = filename + datetime;
      const selectedImage = e.target.files[0]; // get first file
      let formData = new FormData();
      formData.append("photo", selectedImage);
      formData.append("filename", filename);
      this.isUploading = true;
      this.isUploadingFailed = false;
      this.uploadPlacevisitPhoto(formData)
        .then((_res) => {
          this.form2.sections[index].subSections[sub_index].image = _res.data.filepath;
          this.form2.sections[index].subSections[sub_index].type = "image";
          this.isUploading = false;
        })
        .catch((e) => {
          console.log(e);
          this.isUploadingFailed = true;
          this.isUploading = false;
        });
    },

    imageSelectNew(event, selector) {
      event.preventDefault();

      let daySelector = event.target.href;
      daySelector = daySelector.substring(daySelector.indexOf("#") + 1);

      this.$eventHub.$emit("gallery", selector, daySelector);

      $("#destination-image-modal").modal("show");
    },

    isYoutubeURL(url) {
      if (url != undefined || url != "") {
        var regExp = /watch\?v=([a-zA-Z0-9\-_]+)/;
        var match = url.match(regExp);
        if (match) {
          return true;
        } else {
          return false;
        }
      }
    },

    addAssets(index, sub_index) {
      if (this.form2.sections[index].subSections[sub_index].image)
        this.form.sections[index].subSections[sub_index].gallery.push({
          url: this.form2.sections[index].subSections[sub_index].image,
          type: this.form2.sections[index].subSections[sub_index].type,
        });

      this.form2.sections[index].subSections[sub_index].image = "";
    },

    removeAssets(index, sub_index, index_p) {
      this.form.sections[index].subSections[sub_index].gallery.splice(index_p, 1);
    },

    handleImageRemoved: function (file) {
      const data = {
        url: file,
      };
      this.deletePlacevisitPhoto(data);
    },

    addPageImage() {
      this.form.pageImages.push("");
    },

    pageImageRemove(index) {
      if (this.form.pageImages[index] == "") {
        this.form.pageImages.splice(index, 1);
      }
    },

    handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
      var currentdate = new Date();
      var datetime =
        "_" +
        currentdate.getFullYear() +
        "_" +
        (currentdate.getMonth() + 1) +
        "_" +
        currentdate.getDate() +
        "_" +
        currentdate.getHours() +
        "_" +
        currentdate.getMinutes() +
        "_" +
        currentdate.getSeconds();
      let filename = "CUSTOM_PLACES_TO_VISIT";
      filename = filename + datetime;
      let formData = new FormData();
      formData.append("photo", file);
      formData.append("newName", filename);
      this.isUploading = true;
      this.isUploadingFailed = false;
      this.uploadPlacevisitPhoto(formData)
        .then((_res) => {
          Editor.insertEmbed(cursorLocation, "image", _res.data.filepath);
          resetUploader();
          this.isUploading = false;
        })
        .catch((e) => {
          console.log(e);
          this.isUploadingFailed = true;
          this.isUploading = false;
        });
    },
  },
};
</script>
<style scoped>
table tr th {
  min-width: 100px;
  padding: 20px 5px;
  text-align: center;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}
</style>